export default "__VITE_ASSET__FQIfuCr7__"